<template>
    <section class="sc-section">
        <div class="sc-section-title">
            <h2>
                {{ $t("기본 정보") }} <span v-if="warn" class="sc-warn-mark" :title="$t('확인이 필요합니다')">!</span>
            </h2>
        </div>
        <div class="sc-grid-2">
            <div class="sc-field">
                <label for="sc-name">{{ $t("스케줄명") }} <span class="req">*</span></label>
                <valid-input
                    :vid="'스케줄명'"
                    :classList="'form-control'"
                    :inputType="'text'"
                    :inputValue.sync="detail.schdCtrlName"
                    :placeholder="$t('스케줄명')"
                    :rules="rules.COMMON_NAME_RULE"
                    :errorMessage="validMessage.COMMON_NAME_VALID_MESSAGE"
                ></valid-input>
            </div>
            <div class="sc-field">
                <label for="sc-zone">{{ $t("적용 구역") }}</label>
                <select id="sc-zone" v-model="detail.zoneIdx" class="form-control">
                    <option :value="null">{{ $t("선택") }}</option>
                    <option v-for="zone in $store.state.zoneInfo" :key="zone.value" :value="zone.value">
                        {{ zone.text }}
                    </option>
                </select>
            </div>
            <div class="sc-field">
                <label>{{ $t("유효 기간") }}</label>
                <div class="sc-range">
                    <date-picker
                        v-model="detail.startDate"
                        class="form-control"
                        :placeholder="$t('시작일자')"
                        vertical
                        :config="dateConfig"
                    ></date-picker>
                    <span class="sc-meta">~</span>
                    <date-picker
                        v-model="detail.endDate"
                        class="form-control"
                        :placeholder="$t('종료일자')"
                        vertical
                        :config="dateConfig"
                    ></date-picker>
                </div>
            </div>
            <div class="sc-field">
                <label>{{ $t("제어 요일") }}</label>
                <div class="sc-day-toggle" role="group" :aria-label="$t('제어 요일')">
                    <button
                        v-for="day in DAYS"
                        :key="day.key"
                        type="button"
                        :aria-pressed="String(isOn(day.key))"
                        @click="toggleDay(day.key)"
                    >
                        {{ day.label }}
                    </button>
                </div>
                <div class="sc-presets">
                    <button
                        v-for="preset in DAY_PRESETS"
                        :key="preset.label"
                        type="button"
                        @click="applyPreset(preset.keys)"
                    >
                        {{ preset.label }}
                    </button>
                </div>
            </div>
        </div>
        <div class="sc-field" style="margin-top: 16px">
            <label>{{ $t("설명") }}</label>
            <valid-textarea
                :inputType="'text'"
                :inputValue.sync="detail.description"
                :NonStatus="true"
                :rows="3"
                :classList="'desc-ctn form-control'"
                :rules="rules.COMMON_DESC_RULE"
            ></valid-textarea>
        </div>
    </section>
</template>

<script>
import * as rules from "@src/consts/ruleConsts.js";
import * as validMessage from "@src/consts/validMessageConsts.js";
import { DAYS, DAY_PRESETS } from "../../utils/scheduleFormat";

export default {
    props: {
        detail: { type: Object, required: true },
        warn: { type: Boolean, default: false },
    },
    data() {
        return {
            DAYS,
            DAY_PRESETS,
            rules,
            validMessage,
            dateConfig: { format: "YYYY-MM-DD", locale: "ko", viewMode: "days" },
        };
    },
    methods: {
        isOn(key) {
            return !!this.detail.repeatConfig[key];
        },
        toggleDay(key) {
            this.$set(this.detail.repeatConfig, key, this.isOn(key) ? false : "Y");
        },
        applyPreset(keys) {
            DAYS.forEach((d) => this.$set(this.detail.repeatConfig, d.key, keys.includes(d.key) ? "Y" : false));
        },
    },
};
</script>
